import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggedInUserKeys, LoggedInUserService } from '../service/logged-in-user.service';
import { AppUsersDto } from '../model/app-users-dto';

export const authGuard: CanActivateFn = (route, state) => {
  const authService: LoggedInUserService = inject(LoggedInUserService);
  const router: Router = inject(Router);
  let loggedInUser: AppUsersDto;
  loggedInUser = authService.getLoggedInUser(LoggedInUserKeys.LOGGED_IN_USER);
  if (loggedInUser && loggedInUser.authToken && loggedInUser.userRole == 'CANDIDATE') {
    return true;
  }
  router.navigateByUrl('/');
  return false;
  // return true;
};
